module.exports = __webpack_public_path__ + "img/check.298feb91.svg";